import React, { useState, useRef, useEffect } from 'react';
import css from './DevToolsPopover.module.css';
import DevToolsMenu, { MenuView } from '../DevToolsMenu';
import VersionOverridePanel from '../VersionOverridePanel';
import type { DevToolsPosition } from '../../utils';

interface DevToolsPopoverProps {
	onClose: () => void;
	position: DevToolsPosition;
}

const DevToolsPopover = ({ onClose, position }: DevToolsPopoverProps) => {
	const [currentView, setCurrentView] = useState<MenuView>('main');
	const popoverRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
				onClose();
			}
		};

		const handleEscape = (event: KeyboardEvent) => {
			if (event.key === 'Escape') {
				if (currentView !== 'main') {
					setCurrentView('main');
				} else {
					onClose();
				}
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		document.addEventListener('keydown', handleEscape);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			document.removeEventListener('keydown', handleEscape);
		};
	}, [onClose, currentView]);

	const handleViewChange = (view: MenuView) => {
		setCurrentView(view);
	};

	const handleBack = () => {
		setCurrentView('main');
	};

	return (
		<div className={`${css.devToolsPopover} ${css[position]}`} ref={popoverRef}>
			{currentView === 'main' && (
				<DevToolsMenu
					currentView={currentView}
					onViewChange={handleViewChange}
					onClose={onClose}
				/>
			)}
			{currentView === 'version-override' && (
				<VersionOverridePanel onBack={handleBack} onClose={onClose} />
			)}
		</div>
	);
};

export default DevToolsPopover;
